export default {
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      this.recordClick({
        linkText: 'back to top',
      });
    },
  },
};
